import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React, { Component } from "react";
import "whatwg-fetch";
import config from "../config";
class RankingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      results: [],
    };
  }

  componentDidMount() {
    return fetch(config.backend_url + "users/ranking").then((response) => {
      response.json().then((json) => {
        this.setState({ results: json, loading: true });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell><center>順位</center></TableCell>
                <TableCell><center>ユーザー</center></TableCell>
                <TableCell><center>レーティング</center></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.results.map((row, rank) => (
                <TableRow key={row.user_name}>
                  <TableCell><center>{rank + 1}</center></TableCell>
                  <TableCell>
                    <div className="icon_and_name">
                    <center>
                      <a href={"users/" + row.name}><img src={row.image_url} align="middle" width="50" height="50"/></a>
                      <p>
                        <a
                          href={"users/" + row.name}
                          style={{ "textDecoration": "none", color: "black" }}
                        >{row.name}
                        </a>
                      </p>
                    </center>
                    </div>
                  </TableCell>
                  <TableCell><center>{row.rating}</center></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return (
        <div className="App-header">
          <p>Loading...</p>
        </div>
      );
    }
  }
}

export default RankingView;
